import createClient from 'openapi-fetch'
import { env } from '../env.ts'
import { fetch } from './helpers.ts'
import type { components, paths } from './service-manager.types.ts'

export const serviceManager = createClient<paths>({
	baseUrl: env.API_AURORAL,
	fetch,
})

type Schema = components['schemas']
export type SubscriptionEntity = Schema['SubscriptionEntity']
export type ProductEntity = Schema['ProductEntity']
export type CustomerEntity = Schema['CustomerEntity']
export type CreateProductPayload = Schema['ProductCreateDto']
export type UpdateProductPayload = Schema['ProductUpdateDto']
export type UpdateProductStatusPayload = Schema['ProductStatusUpdateDto']
export type ProductOfferingEntity = Schema['ProductOfferingEntity']
